import { QueryKeys } from '@/constants/QueryKeys';
import { useQuery } from 'react-query';
import { DashboardApi } from '@/utilities/api/DashboardApi';
import { useSearchParams } from 'react-router-dom';
import { DashboardData } from '@/pages/CustomerDashboard/interfaces';

export const useDashboard = (accessToken?: string | null) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const notificationId = searchParams.get('n');

  const { data, isLoading, isError, error } = useQuery<DashboardData>(
    [QueryKeys.GET_DASHBOARD_DATA, accessToken],
    () => {
      if (!accessToken) throw new Error('No access token');
      return DashboardApi.getData(
        accessToken,
        notificationId || undefined,
      ) as Promise<DashboardData>;
    },
    {
      enabled: !!accessToken,
      staleTime: 5 * 60 * 1000,
      onSuccess: () => {
        if (notificationId) {
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete('n');
          setSearchParams(newSearchParams, { replace: true });
        }
      },
    },
  );

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
